module.exports = __webpack_public_path__ + "static/media/security-check_6.e495a154.png";